import React, { useEffect, useState } from "react";
import { THUMBNAIL, VIDEO } from "../../components/image";
import "../stories/stories.css";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import StoriesService from "../../services/StoriesService";

const ViewStory = () => {
  const [story, setStory] = useState({});
  const [storyViewers, setStoryViewers] = useState([]);

  const params = useParams();

  const getViewStory = async () => {
    try {
      const response = await StoriesService.getStory(params.id);
      if (response) {
        setStory(response);
      }
    } catch (error) {
      toast.error(error);
    }
  };

  const getStoryViewers = async () => {
    try {
      const response = null;

      setStoryViewers(response);
    } catch (error) {
      toast.error(error);
    }
  };

  useEffect(() => {
    getViewStory();
    getStoryViewers();
  }, []);

  return (
    <div className="container mb-5">
      <div className="overview d-flex align-items-center justify-content-between">
        <div className="title">
          <ion-icon name="add-circle-outline"></ion-icon>
          <span className="text">View Story</span>
        </div>
      </div>

      <div className="mt-4">
        <div className="userInfo mt-4">
          <label>Title</label>
          <div>{story?.title}</div>
        </div>
        {/* <div className="userInfo mt-4">
          <label>URL</label>
          <div>
            "https://youtube.com/shorts/Gfa_IZoTFd0?si=VN8LWIfpPyPMOZNh"
          </div>
        </div>
        <div className="userInfo mt-4">
          <label>Thumbnail</label>
          <div>
            "https://magnificentmidlife.com/wp-content/uploads/2018/05/denise-chan-21350-unsplash.jpg"
          </div>
        </div> */}
        {/* <div className="userInfo mt-4" style={{ position: "relative" }}>
          <div className="viewStory">
            <img src={BASE_URL + story.thumbnailUrl} />
            <ion-icon name="play"></ion-icon>
          </div>
        </div> */}

        <div className="userInfo mt-4">
          <label>Story</label>
          <div className="mt-1">
            <video width="100" height="100" controls>
              Your browser does not support the video tag.
            </video>
          </div>
        </div>

        <div className="userInfo mt-4">
          <label>Status</label>
          <div className="round-bg">{story?.status}</div>
        </div>
      </div>

      <div className="overview d-flex align-items-center justify-content-between">
        <div className="title">
          <ion-icon name="eye-outline"></ion-icon>
          <span className="text">Story Viewers </span>
        </div>
      </div>

      <div className="data-table activityTable">
        <div className="tableStyle">
          <table>
            <thead>
              <tr>
                <th className="users-th">No</th>
                <th className="users-th">Name</th>
                <th className="users-th">Phone Number</th>
                <th className="users-th">Country</th>
                <th className="users-th">Gender</th>
                <th className="users-th">Age Group</th>
                <th className="users-th">Status</th>
              </tr>
            </thead>
            <tbody>
              {storyViewers.map((storyViewer, index) => (
                <tr>
                  <td className="users-td" key={index}>
                    {index + 1}
                  </td>
                  <td className="users-td">
                    <div>{storyViewer.name}</div>
                  </td>
                  <td className="users-td">{storyViewer.phoneNumber}</td>
                  <td className="users-td">{storyViewer.country}</td>
                  <td className="users-td">{storyViewer.gender}</td>
                  <td className="users-td">{storyViewer.ageGroup}</td>
                  <td className="users-td">{storyViewer.status}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ViewStory;
